import { c as _c } from "react/compiler-runtime";
import { IcoShieldFlash40 } from '@onefootprint/icons';
import { Divider, LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import FadeInContainer from '../../../components/fade-in-container';
import IdDocPhotoButtons from '../../../components/id-doc-photo-buttons';
import PromptWithGuidelines from '../../../components/prompt-with-guidelines';
import type { CaptureKind } from '../../../types';
type DocumentPromptViewProps = {
  title: string;
  description: string;
  guidelines: string[];
  alertMessage: string | undefined;
  isMobile: boolean;
  uploadFirst: boolean;
  allowPdf: boolean;
  hasBadConnectivity: boolean | undefined;
  onComplete: (payload: {
    imageFile: File | Blob;
    extraCompressed: boolean;
    captureKind: CaptureKind;
    forcedUpload: boolean;
  }) => void;
  onTakePhoto: () => void;
  onContinueOnMobile: () => void;
};
const DocumentPromptView = t0 => {
  const $ = _c(24);
  const {
    title,
    description,
    guidelines,
    alertMessage,
    isMobile,
    uploadFirst,
    allowPdf,
    hasBadConnectivity,
    onComplete,
    onTakePhoto,
    onContinueOnMobile
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.non-id-doc.pages.document-prompt"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== alertMessage || $[3] !== description || $[4] !== guidelines || $[5] !== title) {
    t3 = <PromptWithGuidelines title={title} icon={IcoShieldFlash40} description={description} guidelines={guidelines} alertMessage={alertMessage} />;
    $[2] = alertMessage;
    $[3] = description;
    $[4] = guidelines;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !isMobile;
  let t5;
  if ($[7] !== allowPdf || $[8] !== hasBadConnectivity || $[9] !== onComplete || $[10] !== onTakePhoto || $[11] !== t4 || $[12] !== uploadFirst) {
    t5 = <IdDocPhotoButtons onComplete={onComplete} uploadFirst={uploadFirst} allowPdf={allowPdf} hideCaptureButton={t4} onTakePhoto={onTakePhoto} hasBadConnectivity={hasBadConnectivity} />;
    $[7] = allowPdf;
    $[8] = hasBadConnectivity;
    $[9] = onComplete;
    $[10] = onTakePhoto;
    $[11] = t4;
    $[12] = uploadFirst;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <div className="h-full flex flex-col gap-6 items-center justify-center">{t3}{t5}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isMobile || $[18] !== onContinueOnMobile || $[19] !== t) {
    t7 = isMobile ? null : <div className="flex flex-col gap-4 items-center"><Divider variant="secondary" className="pt-6 w-[calc(100%+64px)]" /><LinkButton onClick={onContinueOnMobile}>{t(_temp)}</LinkButton></div>;
    $[17] = isMobile;
    $[18] = onContinueOnMobile;
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <FadeInContainer>{t2}{t6}{t7}</FadeInContainer>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default DocumentPromptView;
function _temp($) {
  return $["continue-on-mobile"];
}